import client from 'app/client';

export interface OperationResponse {
  isSuccess: boolean;
  errorMessage?: string;
  id?: string;
}

export interface TunnelMinimalForMatrixDto {
  tunnelId: string;
  code: string;
  designation: string;
  typeTunnel: number; // 1=Individuel, 2=Collectif
  isActive: boolean;
  produitId?: string | null;
  produitCode?: string | null;
  produitLabel?: string | null;
}

export interface CourtierMinimalForMatrixDto {
  courtierId: string;
  personneMoraleId: string;
  designation: string;
  numeroSiret?: string;
  /** Nature de la PM (CRT/CIE/GST/MIA, null = PM cliente). */
  nature?: string | null;
}

export interface HabilitationCellDto {
  tunnelId: string;
  courtierId: string;
  isActive: boolean;
  dateHabilitation?: string;
  dateDesactivation?: string;
  habiliteParAbpUserId?: string;
}

export interface GetHabilitationMatrixResponse {
  plateformeId: string;
  tunnels: TunnelMinimalForMatrixDto[];
  courtiers: CourtierMinimalForMatrixDto[];
  habilitations: HabilitationCellDto[];
}

export async function getHabilitationMatrix(
  plateformeId: string,
): Promise<GetHabilitationMatrixResponse> {
  const { data } = await client.get<GetHabilitationMatrixResponse>(
    `/backoffice/plateformes/${plateformeId}/habilitations-tunnels`,
  );
  return data;
}

export async function setCourtierTunnelHabilitation(
  plateformeId: string,
  tunnelId: string,
  courtierId: string,
  isActive: boolean,
): Promise<OperationResponse> {
  const { data } = await client.patch<OperationResponse>(
    `/backoffice/plateformes/${plateformeId}/habilitations-tunnels/${tunnelId}/courtiers/${courtierId}`,
    { isActive },
  );
  return data;
}
